import pako from 'pako'

export function decodeAndDecompress(base64Str) {
    try {
      const binaryStr = atob(base64Str); // Base64 디코딩
      const byteArray = Uint8Array.from(binaryStr, char => char.charCodeAt(0)); // 바이트 배열로 변환
      const decompressed = pako.ungzip(byteArray, { to: 'string' }); // GZIP 해제
      return decompressed;
    } catch (err) {
      console.error('압축 해제 실패:', err);
      return null;
    }
  }

export const checkEmptyValue = (val, prefix, suffix, defaultVal) => {
    if (typeof val === 'number' && isNaN(val)) return defaultVal || '-'
    if (typeof val === 'undefined' || (typeof val !== 'number' && !val)) return (prefix ? prefix : '') + (defaultVal || '-')
    else return (prefix ? prefix : '') + val + (suffix ? suffix : '')
}

//IBP는 음수 -50까지 표기하여 수정. (함수 이름은 그대로 유지)
export const checkIBPZero = (val, prefix, suffix, isNIBP) => {
    if (isNIBP && val <= 0) return '-'
    if (typeof val === 'number' && val < -50) return '-'
    if (typeof val === 'undefined' || (typeof val !== 'number' && !val)) return (prefix ? prefix : '') + '-'
    else return (prefix ? prefix : '') + val + (suffix ? suffix : '')
}

export const mmHgToKPa = (mmHg) => {
    if (mmHg === null || mmHg === undefined) return '-'
    if (typeof mmHg === 'number' && mmHg < -50) return '-' //-500 표기 되던 것 예외처리
    if (isNaN((mmHg * 0.133322)?.toFixed(1))) return '-'
    return (mmHg * 0.133322)?.toFixed(1);
}

export const celsiusToFahrenheit = (c) => {
    if (c === null || c === undefined) return '--.-'
    if (isNaN(((c * (9 / 5)) + 32)?.toFixed(1))) return '--.-'
    return ((c * (9 / 5)) + 32)?.toFixed(1);
}

export const percentTommHg = (percent) => {
    if (percent === null || percent === undefined) return null
    if (isNaN((760 * (percent / 100))?.toFixed(0))) return null
    return Number((760 * (percent / 100))?.toFixed(0))
}

export const percentToKpa = (percent) => {
    if (percent === null || percent === undefined) return null
    if (isNaN((101.325 * (percent / 100))?.toFixed(1))) return null
    return Number((101.325 * (percent / 100))?.toFixed(1))
}

export const mmHgToPercent = (mmHg) => {    
    if (mmHg === null || mmHg === undefined) return '-'
    const percent = (mmHg / 760) * 100;
    if (isNaN(percent)) return '-'
    return Number(percent.toFixed(1)); // 소수점 첫째 자리까지
};

export const heightUnitConvert = (height, targetUnit) => {
    if (height === null || height === undefined) return null
    if(targetUnit == 'cm'){
        return (height * 2.54).toFixed(2); // cm 변환
    }else if(targetUnit == 'in'){
        return (height / 2.54).toFixed(2);
    }
}

export const weightUnitConvert = (weight, targetUnit) => {
    if (weight === null || weight === undefined) return null
    if(targetUnit == 'kg'){
        return (weight / 2.2046226218).toFixed(2);
    }else if(targetUnit == 'lb'){
        return (weight * 2.2046226218).toFixed(2);
    }
}

export const colorByType = {
    'PR': '#3DFF3D',
    'HR': '#3DFF3D',
    'RR': '#FDDF01',
    'RESP': '#FDDF01',
    'SpO2': '#09F4F0',
    'NIBP': '#FF2B5E',
    'IBP1': '#FF2B5E',
    'IBP2': '#FDDF01',
    'IBP3': '#FF8F32',
    'IBP4': '#34EF8A',
    'EtCO2': '#FFFFFF',
    'InCO2': '#FFFFFF',
    'EWS': '#FFFFFF',
    'awRR': '#FFDDBD',
    'Temp1': '#9B92FF',
    'Temp2': '#9B92FF',
    'EWS': '#FFFFFF',
    'IPI': '#FFFFFF',
    'GAS': '#FF8F32',
    
    'LEADⅠ': '#3DFF3D',         
    'LEADⅡ': '#3DFF3D', 
    'LEADⅢ': '#3DFF3D',
    'CHEST': '#3DFF3D',
    'RESP': '#FDDF01',
    'PLETH': '#09F4F0',
    'GASC01': '#FF8F32',
    'CAPNO': '#FFFFFF',
    'Pads/Paddle': '#3DFF3D',
    'GasAA1': '#FF8F32',
    'GasAA2': '#FF8F32',
    'GasN2O': '#FF8F32',
    'GasCO2': '#FF8F32',
    'GasO2': '#FF8F32',
    'NONE': '#FFFFFFAA'
}

export const minMaxByType = {
    'LEADⅠ': { min: -50, max: 170 },         
    'LEADⅡ': { min: -50, max: 170 }, 
    'LEADⅢ': { min: -50, max: 170 },
    'CHEST': { min: -50, max: 170 },
    'RESP': { min: -300, max: 400 },
    'RR': { min: -80, max: 140 },
    'RESP': { min: -80, max: 140 },
    'PLETH': { min: -50, max: 140 },
    'GASC01': { min: -50, max: 50 },
    'CAPNO': { min: -50, max: 50 },
    'Pads/Paddle': { min: -50, max: 170 },
    'GasAA1': { min: -50, max: 50 },
    'GasAA2': { min: -50, max: 50 },
    'GasN2O': { min: -50, max: 50 },
    'GasCO2': { min: -50, max: 50 },
    'GasO2': { min: -50, max: 50 },
    'NONE': { min: -50, max: 50 }
}

export const dataCountByType = {
    'PLETH': 125,
    'RESP': 125, 
    'RR': 125,
}

export const dataCountPerFrameByType = {
    'PLETH': 5,
    'RESP': 5, 
    'RR': 5,
}

export const dataFullbyType = (isBednumberBig, type, viewType) => {
    switch(type) {
        case 'PLETH':
        case 'RESP':
        case 'RR':
            if (isBednumberBig) return 441
            else return 675
        default:
            if (isBednumberBig) return 882
            else return 1350
    }
}

export const speedStringByType = {
    'LEADⅠ': 'lead1SweepSpeed',         
    'LEADⅡ': 'lead2SweepSpeed', 
    'LEADⅢ': 'lead3SweepSpeed',
    'PLETH': 'plethSweepSpeed',
    'RESP': 'respSweepSpeed',
    'CAPNO': 'capnoSweepSpeed',
    'IBP1': 'ibp1SweepSpeed',
    'IBP2': 'ibp2SweepSpeed',
    'IBP3': 'ibp3SweepSpeed',
    'IBP4': 'ibp4SweepSpeed',
    'GasCO2': 'gasCo2SweepSpeed',
    'GasAA1': 'gasAa1SweepSpeed',
    'GasAA2': 'gasAa2SweepSpeed',
    'GasN2O': 'gasN2oSweepSpeed',
    'GasO2': 'gasO2SweepSpeed',
    'CHEST': 'chestSweepSpeed',
    'Pads/Paddle': 'padsPaddleSweepSpeed',
}

export const unitStringByType = {
    'NIBP': 'nibpUnit',
    'NIBPSYS': 'nibpUnit',
    'NIBPDIA': 'nibpUnit',
    'NIBPMEAN': 'nibpUnit',
    'IBP1': 'ibp1Unit',
    'IBP1SYS': 'ibp1Unit',
    'IBP1DIA': 'ibp1Unit',
    'IBP1MEAN': 'ibp1Unit',
    'IBP2': 'ibp2Unit',
    'IBP2SYS': 'ibp2Unit',
    'IBP2DIA': 'ibp2Unit',
    'IBP2MEAN': 'ibp2Unit',
    'IBP3': 'ibp3Unit',
    'IBP3SYS': 'ibp3Unit',
    'IBP3DIA': 'ibp3Unit',
    'IBP3MEAN': 'ibp3Unit',
    'IBP4': 'ibp4Unit',
    'IBP4SYS': 'ibp4Unit',
    'IBP4DIA': 'ibp4Unit',
    'IBP4MEAN': 'ibp4Unit',
    'EtCO2': 'co2Unit',
    'InCO2': 'co2Unit',
    'Temp1': 'temp1Unit',
    'Temp2': 'temp2Unit',
    'GAS': 'gasUnit'
}

export const valueStringByType = {
    'PR': 'prValue',
    'HR': 'hrValue',
    'RR': 'rrValue',
    'RESP': 'rrValue',
    'SpO2': 'spO2Value',
    // 'NIBP': '#FF2B5E',
    // 'IBP1': '#FF2B5E',
    // 'IBP2': '#FFD600',
    'awRR': 'awRRValue',
    'EtCO2': 'etCO2Value',
    'InCO2': 'inCO2Value',
    'Temp1': 't1Value',
    'Temp2': 't2Value',
    'IPI': 'ipiValue',
    'EWS': 'ewsTotalScore',
    'GasO2Ex': 'o2ValueExp',
    'GasO2In': 'o2ValueInsp',
    'GasCo2Ex': 'co2ValueExp',
    'GasCo2In': 'co2ValueInsp',
    'GasDesEx': 'desValueExp',
    'GasDesIn': 'desValueInsp',
    'GasSevEx': 'sevValueExp',
    'GasSevIn': 'sevValueInsp',
    'GasN2OEx': 'n2oValueExp',
    'GasN2OIn': 'n2oValueInsp',
}

export const valueStringForPlayer = {
    'PR': 'hr',
    'HR': 'hr',
    'RR': 'rrRpm',
    'HR/PR': 'pulseRate',
    'RESP': 'rrRpm',
    'SpO2': 'spo2Percent',
    // 'NIBP': '#FF2B5E',
    // 'IBP1': '#FF2B5E',
    // 'IBP2': '#FFD600',
    'awRR': 'awrrRpm',
    'EtCO2': 'etCo2',
    'InCO2': 'inCo2',
    'Temp': 'temperatureCelsius',
    'Temp1': 'temp1C',
    'Temp2': 'temp2C',
    'IPI': 'ipi',
    'EWS': 'ewsTotalScore',
    'GasO2Ex': 'o2Exp',
    'GasO2In': 'o2Insp',
    'GasCo2Ex': 'co2Exp',
    'GasCo2In': 'co2Insp',
    'GasDesEx': 'desExp',
    'GasDesIn': 'desInsp',
    'GasSevEx': 'sevExp',
    'GasSevIn': 'sevInsp',
    'GasN2OEx': 'n2oExp',
    'GasN2OIn': 'n2oInsp',
    'IBPDia': 'ibpDia',
    'IBPMap': 'ibpMean',
    'IBPSys': 'ibpSys',
    'IBP1Dia': 'ibp1Dia',
    'IBP1Map': 'ibp1Map',
    'IBP1Sys': 'ibp1Sys',
    'IBP2Dia': 'ibp2Dia',
    'IBP2Map': 'ibp2Map',
    'IBP2Sys': 'ibp2Sys',
    'IBP3Dia': 'ibp3Dia',
    'IBP3Map': 'ibp3Map',
    'IBP3Sys': 'ibp3Sys',
    'IBP4Dia': 'ibp4Dia',
    'IBP4Map': 'ibp4Map',
    'IBP4Sys': 'ibp4Sys',
    'NIBPMap': 'nibpMap',
    'NIBPDia': 'nibpDia',
    'NIBPSys': 'nibpSys',
}

export const isDetectingStringByType = {
    'PR': 'ecgMeasurement',
    'HR': 'ecgMeasurement',
    'LEADⅠ': 'ecgMeasurement',         
    'LEADⅡ': 'ecgMeasurement', 
    'LEADⅢ': 'ecgMeasurement',
    'CAPNO': 'co2Measurement',
    'CHEST': 'ecgMeasurement',
    'EtCO2': 'co2Measurement',
    'InCO2': 'co2Measurement',
    'IBP1': 'ibp1Measurement',
    'IBP2': 'ibp2Measurement',
    'IBP3': 'ibp3Measurement',
    'IBP4': 'ibp4Measurement',
    'NIBP': 'nibpMeasurement',
    'SpO2': 'spo2Measurement',
    'PLETH': 'spo2Measurement',
    'Pads/Paddle': 'padsPaddleMeasurement',
    'RESP': 'respirationMeasurement',
    'RR': 'respirationMeasurement',
    'awRR': 'respirationMeasurement',
    'Temp1': 'temperature1Measurement',
    'Temp2': 'temperature2Measurement',
    'BIS': 'bisMeasurement',
    'IPI': 'co2Measurement',
    'GasO2': 'gasO2Measurement',
    'GasAA1': 'gasAA1Measurement',
    'GasAA2': 'gasAA2Measurement',
    'GasCO2': 'gasCO2Measurement',
    'GasN2O': 'gasN2OMeasurement',
}

export const milliVoltageByDigital = {
    // 디지털 값 최대치: 850 ~ -250, 전압 범위 5mV 로 계산(메일로 전달된 수치)
    'LEADⅠ': 0.00909,         
    'LEADⅡ': 0.00909, 
    'LEADⅢ': 0.00909,
    'CHEST': 0.00909,
    'Pads/Paddle': 0.00909,
    // 디지털 값 최대치: 700 ~ -400, 전압 범위 5Ω
    'RR': 0.00909,
    'RESP': 0.00909,
}

export const pixelByMilliVoltage = (min, max, type, height) => {
    const minMilliVoltage = min * milliVoltageByDigital[type]
    const maxMilliVoltage = max * milliVoltageByDigital[type]

    return height / (maxMilliVoltage - minMilliVoltage)
}



export const levelStringByType = {
    'EWS': 'ewsTotalLevel'
}

export const colorByPriority = {
    'High': '#4C000E',
    'Medium': '#4C4900',
    'Low': '#4C4900',
    'Normal': 'transparent',
};

export const getAlarmStringByType = (vsType, valueType) => {
    const typeStringByType = {
        'HR': 'ecgHr',
        'PR': 'ecgHr',
        'RR': 'rr',
        'RESP': 'rr',
        'SpO2': 'pleth',
        'NIBPDIA': 'nibpdia',
        'NIBPMEAN': 'nibpmap',
        'NIBPSYS': 'nibpsys',
        'IBP1DIA': 'ibp1dia',
        'IBP1MEAN': 'ibp1mean',
        'IBP1SYS': 'ibp1sys',
        'IBP2DIA': 'ibp2dia',
        'IBP2MEAN': 'ibp2mean',
        'IBP2SYS': 'ibp2sys',
        'IBP3DIA': 'ibp3dia',
        'IBP3MEAN': 'ibp3mean',
        'IBP3SYS': 'ibp3sys',
        'IBP4DIA': 'ibp4dia',
        'IBP4MEAN': 'ibp4mean',
        'IBP4SYS': 'ibp4sys',
        'EtCO2': 'etCo2',
        'InCO2': 'inCo2',
        'Temp1': 'temp1',
        'Temp2': 'temp2',
        'IPI': 'ipi',
        'GASCO2HIGHEX': 'gasCo2ExHighLimit',
        'GASCO2LOWEX': 'gasCo2ExLowLimit',
        'GASN2OHIGHEX': 'gasN2oExHighLimit',
        'GASN2OLOWEX': 'gasN2oExLowLimit',
        'GASAA1HIGHEX': 'gasAa1ExHighLimit',
        'GASAA1LOWEX': 'gasAa1ExLowLimit',
        'GASAA2HIGHEX': 'gasAa2ExHighLimit',
        'GASAA2LOWEX': 'gasAa2ExLowLimit',
        'GASO2HIGHEX': 'gasO2ExHighLimit',
        'GASO2LOWEX': 'gasO2ExLowLimit',
        'GASCO2HIGHIN': 'gasCo2InHighLimit',
        'GASCO2LOWIN': 'gasCo2InLowLimit',
        'GASN2OHIGHIN': 'gasN2oInHighLimit',
        'GASN2OLOWIN': 'gasN2oInLowLimit',
        'GASAA1HIGHIN': 'gasAa1InHighLimit',
        'GASAA1LOWIN': 'gasAa1InLowLimit',
        'GASAA2HIGHIN': 'gasAa2InHighLimit',
        'GASAA2LOWIN': 'gasAa2InLowLimit',
        'GASO2HIGHIN': 'gasO2InHighLimit',
        'GASO2LOWIN': 'gasO2InLowLimit',
    }

    if (!typeStringByType[vsType]) return null

    if (vsType.indexOf('GAS') !== -1) {
        return typeStringByType[vsType]
    }

    switch(valueType) {
        case 'high':
            return `${typeStringByType[vsType]}HighLimit`
        case 'low':
            return `${typeStringByType[vsType]}LowLimit`
    }
}

export const getVSMFontSize = (viewType, textType, isHalf, isBedNumberBig = false) => {
    if (isHalf) {
        switch (viewType) {
            case 4:
                switch(textType) {
                    case 'type':
                    case 'alarmString':
                        return { fontSize: 12, lineHeight: '13.2px', fontWeight: 400 }
                    case 'unit':
                        return { fontSize: 14, lineHeight: '16.8px', fontWeight: 200 }
                    case 'value':
                        return { fontSize: 40, lineHeight: '40px', letterSpacing: '-3.6px', fontWeight: 400 }
                    case 'nibpValue':
                        return { fontSize: 22, lineHeight: '22px', fontWeight: 500, letterSpacing: '-0.78px' }
                    case 'nibpSubValue':
                        return { fontSize: 18, lineHeight: '20px', fontWeight: 500, letterSpacing: '-0.6px' }
                    case 'nibpAlarm':
                        return { fontSize: 12, lineHeight: '13.2px', fontWeight: 400 }     
                }
                break;
            case 3:
                switch(textType) {
                    case 'type':
                    case 'alarmString':
                        return { fontSize: 16, lineHeight: '17.6px', fontWeight: 400 }
                    case 'unit':
                        return { fontSize: 14, lineHeight: '16.8px', fontWeight: 200 }
                    case 'value':
                        return { fontSize: 50, lineHeight: '50px', letterSpacing: '-3.96px', fontWeight: 400 }
                    case 'nibpValue':
                        return { fontSize: 35, lineHeight: '35px', fontWeight: 500, letterSpacing: '-0.78px' }
                    case 'nibpSubValue':
                        return { fontSize: 26, lineHeight: '28px', fontWeight: 500, letterSpacing: '-0.6px' }
                    case 'nibpAlarm':
                        return { fontSize: 14, lineHeight: '15.4px', fontWeight: 400 } 
                }
                break;
            case 2:
                switch(textType) {
                    case 'type':
                    case 'alarmString':
                        return { fontSize: 16, lineHeight: '17.6px', fontWeight: 400 }
                    case 'unit':
                        return { fontSize: 14, lineHeight: '16.8px', fontWeight: 200 }
                    case 'value':
                        return { fontSize: 40, lineHeight: '40px', letterSpacing: '-3.96px', fontWeight: 400 }
                    case 'nibpValue':
                        return { fontSize: 30, lineHeight: '34.6px', fontWeight: 500, letterSpacing: '-1.44px' }
                    case 'nibpSubValue':
                        return { fontSize: 28, lineHeight: '33.6px', fontWeight: 500, letterSpacing: '-0.84px' }
                    case 'nibpAlarm':
                        return { fontSize: 12, lineHeight: '13.2px', fontWeight: 400 }
                }
                break;
            case 1:
                switch(textType) {
                    case 'type':
                    case 'alarmString':
                        return { fontSize: 20, lineHeight: '20px', fontWeight: 400 }
                    case 'unit':
                        return { fontSize: 16, lineHeight: '17.6px', fontWeight: 200 }
                    case 'value':
                        return { fontSize: 70, lineHeight: '70px', letterSpacing: '-5.28px', fontWeight: 400 }
                    case 'nibpValue':
                        return { fontSize: 40, lineHeight: '44px', fontWeight: 500, letterSpacing: '-1.6px' }
                    case 'nibpSubValue':
                        return { fontSize: 32, lineHeight: '38.4px', fontWeight: 500, letterSpacing: '-0.96px' }
                    case 'nibpAlarm':
                        return { fontSize: 20, lineHeight: '22px', fontWeight: 400, letterSpacing: '-0.6px' }
                }
                break;
        }
    }

    switch (viewType) {
        case 1:
            switch(textType) {
                case 'type':
                case 'alarmString':
                    return { fontSize: 56, lineHeight: '61.6px', fontWeight: 400 }
                case 'unit':
                    return { fontSize: 40, lineHeight: '44px', fontWeight: 200 }
                case 'value':
                    return { fontSize: 200, lineHeight: '200px', letterSpacing: '-12px', fontWeight: 400 }
                case 'nibpValue':
                    return { fontSize: 144, lineHeight: '144px', fontWeight: 400, letterSpacing: '-8.64px' }
                case 'nibpSubValue':
                    return { fontSize: 108, lineHeight: '129.6px', fontWeight: 400, letterSpacing: '-6.48px' }
                case 'nibpAlarm':
                    return { fontSize: 58, lineHeight: '58px', fontWeight: 400, letterSpacing: '-1.74px' }
            }
            break;
        case 4:
            switch(textType) {
                case 'type':
                case 'alarmString':
                    return { fontSize: 28, lineHeight: '30.8px', fontWeight: 400 }
                case 'unit':
                    return { fontSize: 20, lineHeight: '22px', fontWeight: 200 }
                case 'value':
                    return { fontSize: isBedNumberBig ? 90 : 120 , lineHeight: isBedNumberBig ? '90px' : '120px', letterSpacing: '-7.68px', fontWeight: 400 }
                case 'nibpValue':
                    return { fontSize: isBedNumberBig ? 52 : 72, lineHeight: isBedNumberBig ? '52px' : '72px', fontWeight: 400, letterSpacing: '-4.32px' }
                case 'nibpSubValue':
                    return { fontSize: isBedNumberBig ? 42 : 52, lineHeight: isBedNumberBig ? '42px' : '52px', fontWeight: 400, letterSpacing: '-3.12px' }
                case 'nibpAlarm':
                    return { fontSize: isBedNumberBig ? 20 : 30, lineHeight: isBedNumberBig ? '20px' : '30px', fontWeight: 400, letterSpacing: '-0.9px' }
            }
            break;         
        case 6:
            switch(textType) {
                case 'type':
                case 'alarmString':
                    return { fontSize: 24, lineHeight: '26.4px', fontWeight: 400 }
                case 'unit':
                    return { fontSize: 16, lineHeight: '17.6px', fontWeight: 200 }
                case 'value':
                    return { fontSize: 104, lineHeight: '104px', letterSpacing: '-6.24px', fontWeight: 400 }
                case 'nibpValue':
                    return { fontSize: 50, lineHeight: '50px', fontWeight: 400, letterSpacing: '-3.6px' }
                case 'nibpSubValue':
                    return { fontSize: 40, lineHeight: '48px', fontWeight: 500 }
                case 'nibpAlarm':
                    return { fontSize: 20, lineHeight: '26px', fontWeight: 400, letterSpacing: '-0.78px' }
            }
            break;
        case 8:
            switch(textType) {
                case 'type':
                case 'alarmString':
                    return { fontSize: 20, lineHeight: '26.4px', fontWeight: 400, letterSpacing: '-0.6px' }
                case 'unit':
                    return { fontSize: 16, lineHeight: '17.6px', fontWeight: 200 }
                case 'value':
                    return { fontSize: 88, lineHeight: '88px', letterSpacing: '-5.28px', fontWeight: 400 }
                case 'nibpValue':
                    return { fontSize: 60, lineHeight: '46px', fontWeight: 400, letterSpacing: '-3.6px' }
                case 'nibpSubValue':
                    return { fontSize: 40, lineHeight: '38px', fontWeight: 500 }
                case 'nibpAlarm':
                    return { fontSize: 22, lineHeight: '24.2px', fontWeight: 400 }
            }
            break;
        case 10:
            switch(textType) {
                case 'type':
                case 'alarmString':
                    return { fontSize: 18, lineHeight: '19.8px', fontWeight: 400 }
                case 'unit':
                    return { fontSize: 16, lineHeight: '17.6px', fontWeight: 200 }
                case 'value':
                    return { fontSize: 72, lineHeight: '50.8px', letterSpacing: '-4.32px', fontWeight: 400 }
                case 'nibpValue':
                    return { fontSize: 40, lineHeight: '32px', fontWeight: 400, letterSpacing: '-2.4px' }
                case 'nibpSubValue':
                    return { fontSize: 28, lineHeight: '26.6px', fontWeight: 500 }
                case 'nibpAlarm':
                    return { fontSize: 18, lineHeight: '19.8px', fontWeight: 400 }
            }
            break;
        case 12:
        case 14: 
            switch(textType) {
                case 'type':
                case 'alarmString':
                    return { fontSize: 16, lineHeight: '17.6px', fontWeight: 400 }
                case 'unit':
                    return { fontSize: 14, lineHeight: '16.8px', fontWeight: 200 }
                case 'value':
                    return { fontSize: 66, lineHeight: '66px', letterSpacing: '-3.96px', fontWeight: 400 }
                case 'nibpValue':
                    return { fontSize: 32, lineHeight: '32px', fontWeight: 500, letterSpacing: '-0.96px' }
                case 'nibpSubValue':
                    return { fontSize: 26, lineHeight: '28.6px', fontWeight: 500, letterSpacing: '-0.78px' }
                case 'nibpAlarm':
                    return { fontSize: 14, lineHeight: '15.4px', fontWeight: 400 }
            }
            break;
        case 16:
            switch(textType) {
                case 'type':
                case 'alarmString':
                    return { fontSize: 16, lineHeight: '17.6px', fontWeight: 400 }
                case 'unit':
                    return { fontSize: 14, lineHeight: '16.8px', fontWeight: 200 }
                case 'value':
                    return { fontSize: 66, lineHeight: '66px', letterSpacing: '-3.96px', fontWeight: 400 }
                case 'nibpValue':
                    return { fontSize: 28, lineHeight: '28px', fontWeight: 500, letterSpacing: '-0.84px' }
                case 'nibpSubValue':
                    return { fontSize: 22, lineHeight: '24.2px', fontWeight: 500, letterSpacing: '-0.66px' }
                case 'nibpAlarm':
                    return { fontSize: 14, lineHeight: '15.4px', fontWeight: 400 }
            }
            break;
    }
}

export const getNumericFontSize = (viewType, textType, isHalf) => {
    if (isHalf) {
        switch (viewType) {
            case 4:
                switch(textType) {
                    case 'type':
                    case 'alarmString':
                        return { fontSize: 16, lineHeight: '17.6px', fontWeight: 400 }
                    case 'unit':
                        return { fontSize: 14, lineHeight: '16.8px', fontWeight: 200 }
                    case 'value':
                        return { fontSize: 50, lineHeight: '50px', letterSpacing: '-3.6px', fontWeight: 400 }
                    case 'nibpValue':
                        return { fontSize: 26, lineHeight: '26px', fontWeight: 500, letterSpacing: '-0.78px' }
                    case 'nibpSubValue':
                        return { fontSize: 20, lineHeight: '22px', fontWeight: 500, letterSpacing: '-0.6px' }
                    case 'nibpAlarm':
                        return { fontSize: 14, lineHeight: '15.4px', fontWeight: 400 }     
                }
                break;
            case 3:
                switch(textType) {
                    case 'type':
                    case 'alarmString':
                        return { fontSize: 16, lineHeight: '17.6px', fontWeight: 400 }
                    case 'unit':
                        return { fontSize: 14, lineHeight: '16.8px', fontWeight: 200 }
                    case 'value':
                        return { fontSize: 66, lineHeight: '66px', letterSpacing: '-3.96px', fontWeight: 400 }
                    case 'nibpValue':
                        return { fontSize: 26, lineHeight: '26px', fontWeight: 500, letterSpacing: '-0.78px' }
                    case 'nibpSubValue':
                        return { fontSize: 20, lineHeight: '22px', fontWeight: 500, letterSpacing: '-0.6px' }
                    case 'nibpAlarm':
                        return { fontSize: 14, lineHeight: '15.4px', fontWeight: 400 } 
                }
                break;
            case 2:
                switch(textType) {
                    case 'type':
                    case 'alarmString':
                        return { fontSize: 16, lineHeight: '17.6px', fontWeight: 400 }
                    case 'unit':
                        return { fontSize: 14, lineHeight: '16.8px', fontWeight: 200 }
                    case 'value':
                        return { fontSize: 66, lineHeight: '66px', letterSpacing: '-3.96px', fontWeight: 400 }
                    case 'nibpValue':
                        return { fontSize: 30, lineHeight: '33.6px', fontWeight: 500, letterSpacing: '-1.44px' }
                    case 'nibpSubValue':
                        return { fontSize: 28, lineHeight: '33.6px', fontWeight: 500, letterSpacing: '-0.84px' }
                    case 'nibpAlarm':
                        return { fontSize: 18, lineHeight: '19.8px', fontWeight: 400 }
                }
                break;
            case 1:
                switch(textType) {
                    case 'type':
                    case 'alarmString':
                        return { fontSize: 20, lineHeight: '20px', fontWeight: 400 }
                    case 'unit':
                        return { fontSize: 16, lineHeight: '17.6px', fontWeight: 200 }
                    case 'value':
                        return { fontSize: 88, lineHeight: '88px', letterSpacing: '-5.28px', fontWeight: 400 }
                    case 'nibpValue':
                        return { fontSize: 40, lineHeight: '44px', fontWeight: 500, letterSpacing: '-1.6px' }
                    case 'nibpSubValue':
                        return { fontSize: 32, lineHeight: '38.4px', fontWeight: 500, letterSpacing: '-0.96px' }
                    case 'nibpAlarm':
                        return { fontSize: 20, lineHeight: '22px', fontWeight: 400, letterSpacing: '-0.6px' }
                }
                break;
        }
    }

    switch (viewType) {
        case 1:
            switch(textType) {
                case 'type':
                case 'alarmString':
                    return { fontSize: 28, lineHeight: '28px', fontWeight: 400 , letterSpacing: '-0.84px' } //수정 완료
                case 'unit':
                    return { fontSize: 24, lineHeight: '26.4px', fontWeight: 200 } //수정 완료
                case 'value':
                    return { fontSize: 160, lineHeight: '160px', letterSpacing: '-9.6px', fontWeight: 400 } //수정 완료
                case 'nibpValue':
                    return { fontSize: 64, lineHeight: '84px', fontWeight: 400, letterSpacing: '-5.04px' }
                case 'nibpSubValue':
                    return { fontSize: 45, lineHeight: '52px', fontWeight: 400, letterSpacing: '-3%' }
                case 'nibpAlarm':
                    return { fontSize: 32, lineHeight: '36px', fontWeight: 400, letterSpacing: '-1.08px' }
                case 'gasValue':
                    return { fontSize: 28, lineHeight: '36px', fontWeight: 400, letterSpacing: '-1.08px' }
            }
            break;
        case 4:
            switch(textType) {
                case 'type':
                case 'alarmString':
                    return { fontSize: 16, lineHeight: '17.6px' }
                case 'unit':
                    return { fontSize: 14, lineHeight: '16.8px', fontWeight: 200 }
                case 'value':
                    return { fontSize: 60, lineHeight: '60px', letterSpacing: '-6%' }
                case 'nibpValue':
                    return { fontSize: 28, lineHeight: '31.2px', fontWeight: 500, letterSpacing: '-4%' }
                case 'nibpSubValue':
                    return { fontSize: 24, lineHeight: '28.8px', fontWeight: 500, letterSpacing: '-3%' }
                case 'nibpAlarm':
                    return { }
                case 'gasValue':
                    return { fontSize: 11 }
            }
            break;
        case 6:
            switch(textType) {
                case 'type':
                case 'alarmString':
                    return { fontSize: 14, lineHeight: '15.4px' }
                case 'unit':
                    return { fontSize: 14, lineHeight: '15.4px', fontWeight: 200 }
                case 'value':
                    return { fontSize: 60, lineHeight: '60px', letterSpacing: '-6%' }
                case 'nibpValue':
                    return { fontSize: 22, lineHeight: '22px', fontWeight: 500, letterSpacing: '-3%' }
                case 'nibpSubValue':
                    return { fontSize: 16, lineHeight: '17.6px', fontWeight: 500 }
                case 'nibpAlarm':
                    return {  }
                case 'gasValue':
                    return { fontSize: 11 }
            }
            break;
        case 8:
            switch(textType) {
                case 'type':
                    return { fontSize: 14, lineHeight: '15.4px' }
                case 'alarmString':
                    return { fontSize: 14, lineHeight: '14px' }
                case 'unit':
                    return { fontSize: 12, lineHeight: '13.2px', fontWeight: 200 }
                case 'value':
                    return { fontSize: 60, lineHeight: '60px', letterSpacing: '-6%' }
                case 'nibpValue':
                    return { fontSize: 22, lineHeight: '22px', fontWeight: 500, letterSpacing: '-3%' }
                case 'nibpSubValue':
                    return { fontSize: 14, lineHeight: '15.4px', fontWeight: 500 }
                case 'nibpAlarm':
                    return { fontSize: 12, lineHeight: '13.2px' }
                case 'gasValue':
                    return { fontSize: 10 }
            }
            break;
        case 10:
            switch(textType) {
                case 'type':
                case 'alarmString':
                    return { fontSize: 14, lineHeight: '15.4px' }
                case 'unit':
                    return { fontSize: 12, lineHeight: '13.2px', fontWeight: 200 }
                case 'value':
                    return { fontSize: 60, lineHeight: '60px', letterSpacing: '-6%' }
                case 'nibpValue':
                    return { fontSize: 22, lineHeight: '22px', fontWeight: 500, letterSpacing: '-3%' }
                case 'nibpSubValue':
                    return { fontSize: 14, lineHeight: '15.4px', fontWeight: 500 }
                case 'nibpAlarm':
                    return { fontSize: 14, lineHeight: '15.4px' }
                case 'gasValue':
                    return { fontSize: 11 }
            } 
            break;
        case 12:
            switch(textType) {
                case 'type':
                    return { fontSize: 16, lineHeight: '17.6px' }
                case 'alarmString':
                    return { fontSize: 14, lineHeight: '14px' }
                case 'unit':
                    return { fontSize: 12, lineHeight: '13.2px', fontWeight: 200 }
                case 'value':
                    return { fontSize: 60, lineHeight: '60px', letterSpacing: '-6%' }
                case 'nibpValue':
                    return { fontSize: 22, lineHeight: '22px', fontWeight: 500, letterSpacing: '-3%' }
                case 'nibpSubValue':
                    return { fontSize: 16, lineHeight: '17.6px', fontWeight: 500, letterSpacing: '-3%' }
                case 'nibpAlarm':
                    return { fontSize: 14, lineHeight: '15.4px' }
                case 'gasValue':
                    return { fontSize: 11 }
            }  
            break; 
        case 14: 
            switch(textType) {
                case 'type':
                    return { fontSize: 16, lineHeight: '17.6px' }
                case 'alarmString':
                    return { fontSize: 14, lineHeight: '14px' }
                case 'unit':
                    return { fontSize: 12, lineHeight: '13.2px', fontWeight: 200 }
                case 'value':
                    return { fontSize: 60, lineHeight: '60px', letterSpacing: '-6%' }
                case 'nibpValue':
                    return { fontSize: 22, lineHeight: '22px', fontWeight: 500, letterSpacing: '-3%' }
                case 'nibpSubValue':
                    return { fontSize: 16, lineHeight: '17.6px', fontWeight: 500, letterSpacing: '-3%' }
                case 'nibpAlarm':
                    return { fontSize: 14, lineHeight: '15.4px' }
                case 'gasValue':
                    return { fontSize: 11 }
            }  
            break;
        case 16:
            switch(textType) {
                case 'type':
                case 'alarmString':
                    return { fontSize: 14, lineHeight: '14px' }
                case 'unit':
                    return { fontSize: 12, lineHeight: '13.2px', fontWeight: 200 }
                case 'value':
                    return { fontSize: 50, lineHeight: '50px', letterSpacing: '-5%' }
                case 'nibpValue':
                    return { fontSize: 22, lineHeight: '22px', fontWeight: 500, letterSpacing: '-3%' }
                case 'nibpSubValue':
                    return { fontSize: 16, lineHeight: '17.6px', fontWeight: 500, letterSpacing: '-3%' }
                case 'nibpAlarm':
                    return { fontSize: 14, lineHeight: '15.4px' }
                case 'gasValue':
                    return { fontSize: 11 }
            }  
            break;
    }
}

export const getBigBedNumberFontSize = (viewType) => {
    switch(viewType) {
        case 1:
        case 4:
        case 6:
        case 8:
        case 10:
            return { fontSize: 48, lineHeight: '48px', letterSpacing: '-4%', fontWeight: 500} //번호가 짤리는 이슈로 인하여 폰트 사이즈 줄임.
        case 12:
        case 14:
        case 16:
            return { fontSize: 54, lineHeight: '54px', letterSpacing: '-4%', fontWeight: 500}
    }
}

export const fnToNull = (data) => {    
    if (String(data) == 'undefined' || String(data) == 'null') {
        return ''
    } else {
        return data
    }
}

export const pad = (n, width) => {    
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n;
}

//객체 배열에서 Object로 변환
export const parameterArrayToObject = (arr) => {
    return arr.reduce((acc, cur) => {
        acc[cur['measureParameter']] = cur['color'];
        return acc;
    }, {});
};

export const activeTabStyle = {
    background: 'linear-gradient(180deg, #434343 0%, #1F1F1F 100%)',
    boxShadow: '0px 1px 0px 0px #FFFFFF33 inset'
}

export const inActiveTabStyle = {
    background: '#171717',
    borderBottom: '1px solid #353535',
    boxShadow: '0px 0px 0px 1px #3535354D inset'
}